export default class Cursor {
    constructor() {
        this.dot = document.getElementById('cursor-dot')
        this.isActive = window.matchMedia('(pointer: fine)').matches

        if (!this.dot || !this.isActive) return

        this.visible = false

        this.onMove = (event) => {
            if (!this.visible) {
                this.visible = true
                this.dot.style.opacity = '1'
            }

            this.dot.style.left = `${event.clientX}px`
            this.dot.style.top = `${event.clientY}px`
        }

        this.onLeave = () => {
            this.dot.style.opacity = '0'
        }

        this.onEnter = () => {
            if (this.visible) {
                this.dot.style.opacity = '1'
            }
        }

        window.addEventListener('mousemove', this.onMove)
        document.documentElement.addEventListener('mouseleave', this.onLeave)
        document.documentElement.addEventListener('mouseenter', this.onEnter)
    }

    destroy() {
        if (!this.isActive) return

        window.removeEventListener('mousemove', this.onMove)
        document.documentElement.removeEventListener('mouseleave', this.onLeave)
        document.documentElement.removeEventListener('mouseenter', this.onEnter)
    }
}
